import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import dayjs from 'dayjs';
import { typeEstruturaTodasAtvs } from './estrutura_todas_atvs';
import { HeaderDef } from './gerarPDFTodasAtivs';
import { logo_ttivos_base64 } from '../../../../../../../Components/GerarExcel/meta';
import secureLocalStorage from "react-secure-storage";

export const gerarExcelTodasAtivs = async (
    dados: typeEstruturaTodasAtvs[],
    incluir_insumos: boolean,
    incluir_patrimonios: boolean,
    incluir_referencias: boolean,
    posicao_legenda: 'Por célula' | 'Por tag' | 'Por referência',
    headerInfo?: HeaderDef
) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Relatório de Atividades', {
        views: [{ showGridLines: false }]
    });

    worksheet.columns = [
        { header: '', key: 'col1', width: 40 },
        { header: '', key: 'col2', width: 20 },
        { header: '', key: 'col3', width: 25 },
        { header: '', key: 'col4', width: 15 },
        { header: '', key: 'col5', width: 25 },
        { header: '', key: 'col6', width: 15 },
    ];

    let currentRow = 1;

    // ** HEADER **
    worksheet.getRow(currentRow).height = 40; // Linha para a imagem
    worksheet.getRow(currentRow + 1).height = 30; // Linha para o título
    worksheet.getRow(currentRow + 2).height = 20; // Linha para razao social

    // LOGO
    const headerImageId = workbook.addImage({
        base64: logo_ttivos_base64,
        extension: 'png',
    });

    worksheet.addImage(headerImageId, {
        tl: { col: 2.2, row: 0 },
        ext: { width: 121, height: 50 },
        editAs: 'LOGO TTIVOS'
    });
    worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
    const logoRow = worksheet.getRow(currentRow);
    logoRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'center' };
    for (let i = 1; i <= 6; i++) {
        logoRow.getCell(i).border = {
            bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } }
        };
    }
    currentRow++;

    worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
    const titleRow = worksheet.getRow(currentRow);
    titleRow.getCell(1).value = headerInfo?.titulo || 'Relatório de atividades planejadas';
    titleRow.getCell(1).font = { size: 16, bold: true };
    titleRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
    for (let i = 1; i <= 6; i++) {
        titleRow.getCell(i).border = {
            bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } }
        };
    }
    currentRow++;
    worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
    const razaoRow = worksheet.getRow(currentRow);
    razaoRow.getCell(1).value = headerInfo?.razaoSocial || '';
    razaoRow.getCell(1).font = { size: 10 };
    razaoRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
    for (let i = 1; i <= 6; i++) {
        razaoRow.getCell(i).border = {
            bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } }
        };
    }
    currentRow++;

    // ** CLIENTE, SAFRA, CULTURA **
    if (headerInfo?.cliente) {
        worksheet.getRow(currentRow).height = 10; // Espaçamento superior
        currentRow++;

        // --- ROW DE RÓTULOS (Labels) ---
        worksheet.getRow(currentRow).height = 15;
        worksheet.mergeCells(`A${currentRow}:B${currentRow}`);
        worksheet.mergeCells(`C${currentRow}:D${currentRow}`);
        worksheet.mergeCells(`E${currentRow}:F${currentRow}`);

        const labelRow = worksheet.getRow(currentRow);

        labelRow.getCell(1).value = 'CLIENTE';
        labelRow.getCell(3).value = 'SAFRA';
        labelRow.getCell(5).value = 'CULTURA';

        const labelFont = { size: 9, bold: true, color: { argb: 'FF7B7B7B' } };
        const centerAlignment = { horizontal: 'center', vertical: 'middle' } as const;

        labelRow.getCell(1).font = labelFont;
        labelRow.getCell(3).font = labelFont;
        labelRow.getCell(5).font = labelFont;

        labelRow.getCell(1).alignment = centerAlignment;
        labelRow.getCell(3).alignment = centerAlignment;
        labelRow.getCell(5).alignment = centerAlignment;

        currentRow++;

        // --- ROW DE VALORES ---
        worksheet.getRow(currentRow).height = 20;
        worksheet.mergeCells(`A${currentRow}:B${currentRow}`);
        worksheet.mergeCells(`C${currentRow}:D${currentRow}`);
        worksheet.mergeCells(`E${currentRow}:F${currentRow}`);

        const valueRow = worksheet.getRow(currentRow);

        valueRow.getCell(1).value = (headerInfo.cliente || '-').toUpperCase();
        valueRow.getCell(3).value = (headerInfo.safra || '-').toUpperCase();
        valueRow.getCell(5).value = (headerInfo.cultura || '-').toUpperCase();

        const valueFont = { size: 11, bold: true, color: { argb: 'FF000000' } };

        valueRow.getCell(1).font = valueFont;
        valueRow.getCell(3).font = valueFont;
        valueRow.getCell(5).font = valueFont;

        valueRow.getCell(1).alignment = centerAlignment;
        valueRow.getCell(3).alignment = centerAlignment;
        valueRow.getCell(5).alignment = centerAlignment;

        // Adiciona bordas ao redor da nossa tabela de dados
        const borderStyle: ExcelJS.Border = { style: 'thin', color: { argb: 'FF7B7B7B' } };

        // Vamos aplicar as bordas nas células correspondentes das duas linhas
        const labelRowNumber = currentRow - 1;
        const valueRowNumber = currentRow;

        for (let col = 1; col <= 6; col++) {
            worksheet.getRow(labelRowNumber).getCell(col).border = {
                top: borderStyle,
                left: col === 1 || col === 3 || col === 5 ? borderStyle : undefined,
                right: col === 2 || col === 4 || col === 6 ? borderStyle : undefined,
            };
            worksheet.getRow(valueRowNumber).getCell(col).border = {
                bottom: borderStyle,
                left: col === 1 || col === 3 || col === 5 ? borderStyle : undefined,
                right: col === 2 || col === 4 || col === 6 ? borderStyle : undefined,
            };
        }

        currentRow++;
    }

    // Coleta todas as referências únicas
    const uniqueReferences: string[] = [];
    if (incluir_referencias && posicao_legenda === 'Por referência') {
        dados.forEach((propriedade) => {
            propriedade.lista_atividades_por_talhao.forEach((talhao) => {
                talhao.lista_atividades.forEach((atv) => {
                    if (atv.nome_atv_vinculada && atv.nome_atv_vinculada.trim() !== '') {
                        if (!uniqueReferences.includes(atv.nome_atv_vinculada)) {
                            uniqueReferences.push(atv.nome_atv_vinculada);
                        }
                    }
                });
            });
        });
    }

    // Escreve a legenda de referências
    if (incluir_referencias && posicao_legenda === 'Por referência' && uniqueReferences.length > 0) {
        currentRow++;
        worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
        const legendTitleRow = worksheet.getRow(currentRow);
        legendTitleRow.getCell(1).value = 'ATIVIDADES VINCULADAS';
        legendTitleRow.getCell(1).font = { bold: true, size: 9, color: { argb: 'FF137333' } };
        legendTitleRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF4FBF7' } };
        legendTitleRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' };
        legendTitleRow.height = 18;
        applyBorders(currentRow, 'FF5DA57D');
        currentRow++;

        worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
        const legendContentRow = worksheet.getRow(currentRow);
        legendContentRow.getCell(1).value = uniqueReferences.map((ref, idx) => `[${idx + 1}] ${ref}`).join('      ');
        legendContentRow.getCell(1).font = { bold: true, size: 8.5, color: { argb: 'FF4D4D4D' } };
        legendContentRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF4FBF7' } };
        legendContentRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
        legendContentRow.height = 20;
        applyBorders(currentRow, 'FF5DA57D');
        currentRow++;
    }

    currentRow++; // linha vazia

    function applyBorders(rowNum: number, color = 'FF000000') {
        const row = worksheet.getRow(rowNum);
        for (let i = 1; i <= 6; i++) {
            row.getCell(i).border = {
                top: { style: 'thin', color: { argb: color } },
                left: { style: 'thin', color: { argb: color } },
                bottom: { style: 'thin', color: { argb: color } },
                right: { style: 'thin', color: { argb: color } }
            };
        }
    }

    dados.forEach((propriedade) => {
        worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
        const propRow = worksheet.getRow(currentRow);
        propRow.getCell(1).value = propriedade.nome_propriedade || "PROPRIEDADE NÃO INFORMADA";
        propRow.getCell(1).font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 12 };
        propRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF5DA57D' } };
        propRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
        propRow.height = 25;
        applyBorders(currentRow, 'FF165C13');
        currentRow++;

        propriedade.lista_atividades_por_talhao.forEach((talhao) => {
            worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
            const talhaoRow = worksheet.getRow(currentRow);
            talhaoRow.getCell(1).value = talhao.nome_talhao || "TALHÃO NÃO INFORMADO";
            talhaoRow.getCell(1).font = { bold: true, color: { argb: 'FF165C13' }, size: 11 };
            talhaoRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
            talhaoRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
            talhaoRow.height = 20;
            applyBorders(currentRow, 'FF165C13');
            currentRow++;

            const headerTitles = ['Atividade', 'Operação', 'Datas', 'Área', 'Área executada', 'Concluída'];
            const colHeaderRow = worksheet.getRow(currentRow);
            headerTitles.forEach((title, index) => {
                const cell = colHeaderRow.getCell(index + 1);
                cell.value = title;
                cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0E743F' } };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
            colHeaderRow.height = 20;
            applyBorders(currentRow, 'FF000000');
            currentRow++;

            let globalAtvIndex = 0;

            talhao.lista_atividades.forEach((atv) => {

                const formatarData = (dInicio: string | null, dFim: string | null) => {
                    if (!dInicio && !dFim) return '-';
                    const i = dInicio ? dayjs(dInicio).format("DD/MM/YY") : '?';
                    const f = dFim ? dayjs(dFim).format("DD/MM/YY") : '?';
                    if (i === f) return i;
                    return `${i} - ${f}`;
                };

                const dataStr = formatarData(atv.data_inicio, atv.data_final);
                const zebraColor = (globalAtvIndex % 2 === 0) ? 'FFFFFFFF' : 'FFE5F1E1';

                const atvRow = worksheet.getRow(currentRow);

                // Build rich text for activity description, including ID, and tags (Ref, DAP, DAE)
                const richTextParts: any[] = [];

                richTextParts.push({ text: atv.descricao || '-', font: { size: 10 } });

                const hasVinculada = incluir_referencias && atv.nome_atv_vinculada && atv.nome_atv_vinculada.trim() !== '';

                // Se for modo "Por tag", adiciona a tag de referência destacada no topo da célula
                if (hasVinculada && posicao_legenda === 'Por tag') {
                    const capitalizedRef = atv.nome_atv_vinculada.trim().charAt(0).toUpperCase() + atv.nome_atv_vinculada.trim().slice(1).toLowerCase();
                    const tagColor = Number(atv.dias) >= 0 ? 'FF51C11A' : 'FF1A73E8';
                    richTextParts.unshift({
                        text: `(${Number(atv.dias) > 0 ? "+" : ""}${atv.dias} dias) de ${capitalizedRef}\n`,
                        font: { size: 9, bold: true, color: { argb: tagColor } }
                    });
                }

                const tags: { text: string; color: string }[] = [];
                const formatarChipValor = (num: number) => {
                    const absVal = Math.abs(num);
                    const prefixo = num < 0 ? '-' : '';
                    const numStr = absVal < 10 ? `0${absVal}` : String(absVal);
                    return `${prefixo}${numStr}`;
                };

                // Adiciona o chip de dias se não estiver no topo (modo "Por tag")
                if (!(hasVinculada && posicao_legenda === 'Por tag') && atv.dias !== undefined && atv.dias !== null && !isNaN(atv.dias) && Number(atv.dias) !== 0) {
                    const tagColor = Number(atv.dias) >= 0 ? 'FF51C11A' : 'FF1A73E8';
                    let chipText = `*${Number(atv.dias) > 0 ? "+" : ""}${atv.dias} D`;
                    if (hasVinculada && posicao_legenda === 'Por referência') {
                        const refIdx = uniqueReferences.indexOf(atv.nome_atv_vinculada);
                        if (refIdx !== -1) {
                            chipText = `*${Number(atv.dias) > 0 ? "+" : ""}${atv.dias} D [${refIdx + 1}]`;
                        }
                    }
                    tags.push({ text: chipText, color: tagColor });
                }

                if (atv.dias_apos_plantio !== undefined && atv.dias_apos_plantio !== null && !isNaN(atv.dias_apos_plantio) && Number(atv.dias_apos_plantio) > 0) {
                    tags.push({ text: `${formatarChipValor(atv.dias_apos_plantio)} DAP`, color: 'FF137333' });
                }
                if (atv.dias_apos_emergencia !== undefined && atv.dias_apos_emergencia !== null && !isNaN(atv.dias_apos_emergencia) && Number(atv.dias_apos_emergencia) > 0) {
                    tags.push({ text: `${formatarChipValor(atv.dias_apos_emergencia)} DAE`, color: 'FF137333' });
                }

                if (tags.length > 0) {
                    richTextParts.push({ text: `\n` });
                    tags.forEach((tag, idx) => {
                        richTextParts.push({ text: `(${tag.text})`, font: { size: 8.5, color: { argb: tag.color }, bold: true } });
                        if (idx < tags.length - 1) {
                            richTextParts.push({ text: '  |  ', font: { size: 8.5, color: { argb: 'FF7B7B7B' } } });
                        }
                    });
                }

                // Se for modo "Por célula", adiciona a legenda da referência no rodapé da célula
                if (hasVinculada && posicao_legenda === 'Por célula') {
                    const tagColor = Number(atv.dias) >= 0 ? 'FF51C11A' : 'FF1A73E8';
                    richTextParts.push({
                        text: `\n* ${atv.nome_atv_vinculada}`,
                        font: { size: 8, bold: true, color: { argb: tagColor } }
                    });
                }

                atvRow.getCell(1).value = { richText: richTextParts };
                atvRow.getCell(2).value = atv.tipo_operacao || '-';
                atvRow.getCell(3).value = dataStr;
                atvRow.getCell(4).value = `${atv.area} ha`;
                atvRow.getCell(5).value = `${atv.area_executada} ha (${atv.porcentagem_executada}%)`;
                atvRow.getCell(6).value = atv.concluido ? 'SIM' : 'NÃO';

                atvRow.height = 25;

                for (let i = 1; i <= 6; i++) {
                    const cell = atvRow.getCell(i);
                    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: zebraColor } };
                }

                if (atv.concluido) {
                    atvRow.getCell(6).font = { bold: true, color: { argb: 'FFFFFFFF' } };
                    atvRow.getCell(6).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF01C16C' } };
                } else {
                    atvRow.getCell(6).font = { bold: true, color: { argb: 'FF000000' } };
                }

                applyBorders(currentRow, 'FF000000');
                currentRow++;

                const temObservacao = !!(atv.observacao && atv.observacao.trim() !== '');

                if (incluir_insumos || incluir_patrimonios || temObservacao) {

                    if (temObservacao) {
                        worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
                        const obsHeaderRow = worksheet.getRow(currentRow);
                        obsHeaderRow.getCell(1).value = '    Observação';
                        obsHeaderRow.getCell(1).font = { bold: true, size: 10 };
                        obsHeaderRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' };
                        obsHeaderRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: zebraColor } };
                        applyBorders(currentRow, 'FF000000');
                        currentRow++;

                        worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
                        const obsRow = worksheet.getRow(currentRow);
                        obsRow.getCell(1).value = `        ${atv.observacao}`;
                        obsRow.getCell(1).font = { size: 9, color: { argb: 'FF4D4D4D' } };
                        obsRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
                        obsRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: zebraColor } };
                        obsRow.height = 25;
                        applyBorders(currentRow, 'FF000000');
                        currentRow++;
                    }

                    if (incluir_insumos) {
                        worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
                        const insumosHeaderRow = worksheet.getRow(currentRow);
                        insumosHeaderRow.getCell(1).value = '    Insumos Planejados';
                        insumosHeaderRow.getCell(1).font = { bold: true, size: 10 };
                        insumosHeaderRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' };
                        insumosHeaderRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: zebraColor } };
                        applyBorders(currentRow, 'FF000000');
                        currentRow++;

                        if (atv.insumos && atv.insumos.length > 0) {
                            atv.insumos.forEach((insu: any) => {
                                const detalhes = () => {
                                    switch (insu?.cod_tipo) {
                                        case 8:
                                            return `Tipo: ${insu.nome_tipo || '-'} | Doses: ${insu.doses_inoculante || '-'} | Dosagem: ${insu.dosagem || 0} ${insu.nome_medida || ''}/ha | Qtde: ${insu.quantidade_insumo || 0} ${insu.observacao ? `| Obs: ${insu.observacao}` : ''}`;
                                        default:
                                            return `Tipo: ${insu.nome_tipo || '-'} | Dosagem: ${insu.dosagem || 0} ${insu.nome_medida || ''}/ha | ${atv.atv_is_pulverizacao ? 'Total (área)' : 'Qtde'}: ${insu.quantidade_insumo || 0} ${(atv.atv_is_pulverizacao && insu.no_tanque > 0) ? `| No Tanque: ${insu.no_tanque || 0} L` : ''} ${insu.observacao ? `| Obs: ${insu.observacao}` : ''}`;
                                    }
                                };
                                worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
                                const insuRow = worksheet.getRow(currentRow);
                                insuRow.getCell(1).value = {
                                    richText: [
                                        { text: `        • ${insu.insumo_nome || '-'}\n`, font: { bold: true, size: 10 } },
                                        { text: detalhes(), font: { size: 9, color: { argb: 'FF4D4D4D' } } }
                                    ]
                                };
                                insuRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
                                insuRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: zebraColor } };
                                insuRow.height = 30;
                                applyBorders(currentRow, 'FF000000');
                                currentRow++;
                            });
                        } else {
                            worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
                            const insuRow = worksheet.getRow(currentRow);
                            insuRow.getCell(1).value = `        Não possui insumos cadastrados`;
                            insuRow.getCell(1).font = { size: 9, italic: true, color: { argb: 'FF4D4D4D' } };
                            insuRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' };
                            insuRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: zebraColor } };
                            applyBorders(currentRow, 'FF000000');
                            currentRow++;
                        }
                    }

                    if (incluir_patrimonios) {
                        worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
                        const patHeaderRow = worksheet.getRow(currentRow);
                        patHeaderRow.getCell(1).value = '    Patrimônios Planejados';
                        patHeaderRow.getCell(1).font = { bold: true, size: 10 };
                        patHeaderRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' };
                        patHeaderRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: zebraColor } };
                        applyBorders(currentRow, 'FF000000');
                        currentRow++;

                        if (atv.patrimonios && atv.patrimonios.length > 0) {
                            atv.patrimonios.forEach((pat: any) => {
                                const label = pat.horimetro_inicial || pat.horimetro_final ? 'Horímetro' : 'Quilometragem';
                                worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
                                const patRow = worksheet.getRow(currentRow);
                                patRow.getCell(1).value = {
                                    richText: [
                                        { text: `        • ${pat.patrimonio_nome || pat.nome || '-'}\n`, font: { bold: true, size: 10 } },
                                        { text: `          ${label} inicial: ${pat.horimetro_inicial ?? pat.quilometragem_inicial ?? '-'} | ${label} final: ${pat.horimetro_final ?? pat.quilometragem_final ?? '-'}`, font: { size: 9, color: { argb: 'FF4D4D4D' } } }
                                    ]
                                };
                                patRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
                                patRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: zebraColor } };
                                patRow.height = 30;
                                applyBorders(currentRow, 'FF000000');
                                currentRow++;
                            });
                        } else {
                            worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
                            const patRow = worksheet.getRow(currentRow);
                            patRow.getCell(1).value = `        Não possui patrimônios cadastrados`;
                            patRow.getCell(1).font = { size: 9, italic: true, color: { argb: 'FF4D4D4D' } };
                            patRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' };
                            patRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: zebraColor } };
                            applyBorders(currentRow, 'FF000000');
                            currentRow++;
                        }
                    }

                }

                globalAtvIndex++;
            });
            currentRow++; // empty space between talhoes
        });
        currentRow++; // empty space between propriedades
    });

    // ** FOOTER **
    const espacoRow = worksheet.addRow([]);
    espacoRow.height = 20;

    const email_usuario_logado = secureLocalStorage.getItem('Itens')?.[0]?.email?.toLowerCase() || '';
    const footerRow = worksheet.addRow([]);
    footerRow.getCell(1).value = `Gerador por: ${email_usuario_logado} - ${dayjs().format('DD/MM/YYYY HH:mm:ss')}`;
    footerRow.font = { italic: true };
    footerRow.alignment = { horizontal: 'center', vertical: 'middle' };

    for (let i = 1; i <= 6; i++) {
        worksheet.getCell(`${String.fromCharCode(64 + i)}${footerRow.number}`).border = {
            top: { style: 'thin', color: { argb: '5da57d' } }
        };
    }
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);
    footerRow.height = 25;

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer as BlobPart], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, `Relatorio_Atividades_${dayjs().format("DD_MM_YYYY_HH_mm")}.xlsx`);
};
